// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2VLlr","disabled":"FileBtn_disabled__2xdwh","warn":"FileBtn_warn__171Zf","fade":"FileBtn_fade__21d_J"};